import { FilterState } from "./reducer"

export const getFilters = (state: FilterState) => {
  let filters = ""

  if (state.productGroup) {
    filters += ` AND product_group:${state.productGroup}`
  }
  if (state.size) {
    filters += ` AND size:${state.size}`
  }
  if (state.style) {
    filters += ` AND style:${state.style}`
  }
  return filters
}
